import SpecialOffers from './SpecialOffers';

export default SpecialOffers;